import {
  anthropicDocumentMimeTypes,
  anthropicImageMimeTypes,
  castToTextMimeTypes,
} from '@sc/bedrock/messages';
// Prose/document formats that go through the chunking pipeline for RAG indexing
// (also used as the accept array for chunkable file inputs) are exactly the
// types extractText can handle.
import { extractableDocumentMimeTypes } from '@sc/document-processing/mime-types';

export const supportedAIProcessingMimeTypes = {
  chunkableTextMimeTypes: extractableDocumentMimeTypes,
  anthropicImageMimeTypes,
  anthropicDocumentMimeTypes,
  castToTextMimeTypes,
};
